module.exports = __webpack_public_path__ + "img/ai03.691d3384.svg";